const ADD_SEC_USER = "ADD_SEC_USER";
const REMOVE_SEC_USER = "REMOVE_SEC_USER";
const EDIT_SEC_PROFILE = "EDIT_SEC_PROFILE";
const ADD_SEC_PROFILE = "ADD_SEC_PROFILE";
const ADD_SEC_ROLE = "ADD_SEC_ROLE";
const EDIT_SEC_ROLE = "EDIT_SEC_ROLE";
const ADD_CITATION_FILE = "ADD_CITATION_FILE";
const defaultDialogs = {
  addSecUser: null,
  removeSecUser: null,
  addEditClearanceLevel: null,
  addSecRole: null,
  addSecProfile: null,
  editSecRole: null,
  editSecProfile: null,
  addCitationFile: null,
};

export const showAddSecUser =
  (data = {}) =>
  (dispatch) => {
    dispatch({ type: ADD_SEC_USER, data });
  };

export const closeAddSecUser = () => (dispatch) =>
  dispatch({ type: ADD_SEC_USER, data: null });

export const showRemoveSecUser =
  (data = {}) =>
  (dispatch) =>
    dispatch({ type: REMOVE_SEC_USER, data });

export const closeRemoveSecUser = () => (dispatch) =>
  dispatch({ type: REMOVE_SEC_USER, data: null });

export const showAddSecProfile =
  (data = {}) =>
  (dispatch) => {
    dispatch({ type: ADD_SEC_PROFILE, data });
  };
export const closeAddSecProfile = () => (dispatch) =>
  dispatch({ type: ADD_SEC_PROFILE, data: null });

export const showEditSecProfile =
  (data = {}) =>
  (dispatch) =>
    dispatch({ type: EDIT_SEC_PROFILE, data });

export const closeEditSecProfile = () => (dispatch) =>
  dispatch({ type: EDIT_SEC_PROFILE, data: null });

export const showAddSecRole =
  (data = {}) =>
  (dispatch) =>
    dispatch({ type: ADD_SEC_ROLE, data });
export const closeAddSecRole = () => (dispatch) =>
  dispatch({ type: ADD_SEC_ROLE, data: null });

export const showEditSecRole =
  (data = {}) =>
  (dispatch) =>
    dispatch({ type: EDIT_SEC_ROLE, data });
export const closeEditSecRole = () => (dispatch) =>
  dispatch({ type: EDIT_SEC_ROLE, data: null });

export const closeCitationFile =
  (data = {}) =>
  (dispatch) =>
    dispatch({ type: ADD_CITATION_FILE, data: null });

export default function DialogsReducer(state = defaultDialogs, action) {
  switch (action.type) {
    case ADD_SEC_USER:
      return { ...state, addSecUser: action.data };
    case REMOVE_SEC_USER:
      return { ...state, removeSecUser: action.data };
    case ADD_SEC_PROFILE:
      return { ...state, addSecProfile: action.data };
    case EDIT_SEC_PROFILE:
      return { ...state, editSecProfile: action.data };
    case ADD_SEC_ROLE:
      return { ...state, addSecRole: action.data };
    case EDIT_SEC_ROLE:
      return { ...state, editSecRole: action.data };
    case ADD_CITATION_FILE:
      return {
        ...state,
        addCitationFile: action.data,
      };
    default:
      return state;
  }
}
